// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';
import { getIconPath } from '@tcp/core/src/utils';

export default css`
  &.trending-in-category-carousel-wrapper {
    position: relative;
    margin: 28px 0 14px 0;

    @media ${(props) => props.theme.mediaQuery.medium} {
      margin: 32px 0 38px 0;
    }

    @media ${(props) => props.theme.mediaQuery.large} {
      margin: 32px 0 66px 0;
    }

    .scroll-container {
      display: flex;
      overflow-x: scroll;
      column-gap: ${(props) => props.theme.spacing.ELEM_SPACING.XS};

      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none; /* Firefox */

      &::-webkit-scrollbar {
        display: none;
      }
    }

    .carousel-arrows {
      position: absolute;
      top: 50%;
      transform: translate(0, -50%);
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 40px;
      min-height: 40px;
      border-radius: 6px;
      box-sizing: border-box;
      border: 1px solid #d8d8d8;
      background: rgba(255, 255, 255, 0.9);
      z-index: 1;
      cursor: pointer;

      .left-arrow,
      .right-arrow {
        width: 11px;
        height: 18px;
        background: url(${() => getIconPath('icon-carrot-grey-large')}) no-repeat center center;
      }

      .left-arrow {
        transform: rotate(180deg);
      }
    }

    .carousel-arrows.carousel-left-arrow {
      left: 32px;
    }
    .carousel-arrows.carousel-right-arrow {
      right: 32px;
    }

    .trending-in-category-carousel {
      display: flex;
      align-items: center;
      column-gap: 8px;
      position: relative;
      min-height: 248px;

      @media ${(props) => props.theme.mediaQuery.large} {
        min-height: 415px;
        column-gap: 18px;
      }

      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.XS_1};
      }
      @media ${(props) => props.theme.mediaQuery.mediumOnly} {
        margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.XS_1};
      }

      .trending-in-category-carousel-header,
      .trending-in-category-recommendation-tile {
        box-sizing: border-box;
        min-width: 144px;
        max-width: 144px;
        padding: 8px;

        /* stylelint-disable max-nesting-depth */
        @media ${(props) => props.theme.mediaQuery.large} {
          min-width: 245px;
          max-width: 245px;
          padding: 14px;
        }
      }

      .trending-in-category-recommendation-tile,
      .trending-in-category-recommendation-tile.skeleton {
        height: 236.72px;
        @media ${(props) => props.theme.mediaQuery.large} {
          height: 401.95px;
        }
      }

      .trending-in-category-carousel-header {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        padding: 8px 8px 8px 12px;
        color: #000;
        font-family: Nunito;
        font-style: normal;
        font-weight: 900;
        line-height: 150%;
        text-transform: capitalize;
        box-sizing: border-box;
        white-space: normal;
        word-break: break-word;

        @media ${(props) => props.theme.mediaQuery.large} {
          font-size: 26px;
          padding: 14px 14px 14px 30px;
        }
      }

      .carousel-background {
        position: absolute;
        width: 100%;
        height: 174px;
        background: #dbebf8;
        z-index: -1;
        left: 0;

        @media ${(props) => props.theme.mediaQuery.large} {
          height: 291px;
        }
      }
    }
  }
`;
